const initialState = [];

function reducer(state = initialState, action) {
    if (action.type === 'CUSTOMER_ISSUE_USERS_SUCCESS') {
        return action.payload ?? [];
    }
    return state;
}

export default reducer;
